<template>
  <van-tabbar
    v-model="currentIndex"
    :fixed="false"
    :border="false"
    active-color="#2599f8"
    inactive-color="#93a2b1"
    z-index="100"
    class="app-tabbar norem"
    @change="onChange"
  >
    <van-tabbar-item v-for="item in tabList" :key="item.path">
      <span>{{ item.text }}</span>
      <img
        slot="icon"
        slot-scope="props"
        class="tab-icon"
        :src="props.active ? item.activeIcon || item.icon : item.icon"
        alt=""
      />
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
import { isLoggedIn, isWhiteRoute, redirectToLogin } from "@/utils/permission";

export default {
  name: "TabBar",
  data() {
    return {
      currentIndex: 0,
      tabItems: [
        {
          textKey: "tabbar.home",
          icon: require("@/assets/tabBar/nav1.webp"),
          activeIcon: require("@/assets/tabBar/nav1-1.webp"),
          path: "/",
        },
        {
          textKey: "tabbar.discount",
          icon: require("@/assets/tabBar/nav2.webp"),
          activeIcon: require("@/assets/tabBar/nav2-1.webp"),
          path: "/discount",
        },
        {
          textKey: "tabbar.customer",
          icon: require("@/assets/tabBar/nav3.webp"),
          activeIcon: require("@/assets/tabBar/nav3-1.webp"),
          path: "/customer",
        },
        {
          textKey: "tabbar.invite",
          icon: require("@/assets/tabBar/nav4.png"),
          activeIcon: require("@/assets/tabBar/nav4-1.png"),
          path: "/invite",
        },
        {
          textKey: "tabbar.mine",
          icon: require("@/assets/tabBar/nav5.webp"),
          activeIcon: require("@/assets/tabBar/nav5-1.webp"),
          path: "/setting",
        },
      ],
    };
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },
    tabList() {
      void this.locale;
      return this.tabItems.map((item) => ({
        ...item,
        text: this.$t(item.textKey),
      }));
    },
  },
  watch: {
    $route: {
      handler(route) {
        this.syncIndex(route.path);
      },
      immediate: true,
    },
  },
  mounted() {
    this.updateTabBarOffset();
    window.addEventListener("resize", this.updateTabBarOffset);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateTabBarOffset);
    document.documentElement.style.removeProperty("--tab-bar-offset");
  },
  methods: {
    updateTabBarOffset() {
      this.$nextTick(() => {
        const el = this.$el;
        if (!el) return;
        const height = el.getBoundingClientRect().height;
        if (height > 0) {
          document.documentElement.style.setProperty(
            "--tab-bar-offset",
            `${height}px`
          );
        }
      });
    },
    syncIndex(path) {
      const index = this.tabList.findIndex((item) => item.path === path);
      if (index !== -1) {
        this.currentIndex = index;
      }
    },
    onChange(index) {
      const item = this.tabList[index];
      if (!item) return;

      if (!item.path || item.path === this.$route.path) {
        this.syncIndex(this.$route.path);
        return;
      }

      if (!isLoggedIn() && !isWhiteRoute(item.path)) {
        this.$nextTick(() => this.syncIndex(this.$route.path));
        redirectToLogin(this.$router);
        return;
      }

      this.$router.push(item.path);
      this.$emit("tab-change", index, item);
    },
  },
};
</script>

<style lang="scss">
.app-tabbar.norem.van-tabbar {
  position: relative !important;
  flex-shrink: 0;
  width: 100%;
  max-width: 750px;
  height: auto !important;
  min-height: calc(44px + var(--inset-bottom, 0px));
  margin: 0 auto;
  padding: 0;
  padding-bottom: var(--inset-bottom, 0px);
  background: #ffffff;
  box-shadow: 0 -4px 16px rgba(0, 0, 0, 0.04);
  box-sizing: border-box;
  overflow: hidden;
}

.app-tabbar.norem .van-tabbar-item {
  font-size: 10px;
  line-height: 1;
  padding: 3px 0 1px;
  min-width: 0;
  overflow: hidden;
  justify-content: flex-end;
}

.app-tabbar.norem .van-tabbar-item__icon {
  width: 24px !important;
  height: 24px !important;
  min-height: 24px !important;
  max-height: 24px !important;
  margin-bottom: 1px !important;
  overflow: hidden;
  display: flex !important;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.app-tabbar.norem .van-tabbar-item__text {
  font-size: 10px;
  line-height: 1.1;
  margin-top: 0;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.app-tabbar.norem .tab-icon {
  width: 24px;
  height: 24px;
  max-width: 24px;
  max-height: 24px;
  object-fit: contain;
  display: block;
  flex-shrink: 0;
}
</style>
